/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p"
  }, _provideComponents(), props.components);
  return React.createElement(React.Fragment, null, React.createElement(_components.p, null, "Why would someone need a technical blog in 2019? Everything is written, everything is said, you say."), "\n", React.createElement(_components.p, null, "I think this place will be especially usefull when I decide to try out some programming R&D with undefined result."), "\n", React.createElement(_components.p, null, "I will start this blog with series of articles about Unreal Engine 4 and C++ in the context of game development. Reason is simple: these are the technologies I work with most often these days."), "\n", React.createElement(_components.p, null, "Happy reading!"));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
